import { useEffect, useState } from 'react';
import { useDebouncedEffect, useElementSize } from '../../CustomHooks';
import styles from './ExpandableGeneric.module.scss';

export type ExpandableProps = {
  isExpanded: boolean;
  children: React.ReactNode;
  resizeTrigger: boolean;
};

const ExpandableGenericDynamic = ({ isExpanded, children, resizeTrigger }: ExpandableProps): JSX.Element => {
  const [contentHeight, setContentHeight] = useState('0px');
  const [expandableRef, { height }] = useElementSize();

  const handleResize = () => {
    const newTextHeight =
      !isExpanded || expandableRef.current === null ? `0px` : `${expandableRef.current.scrollHeight}px`;
    setContentHeight(newTextHeight);
  };

  useDebouncedEffect(() => window.addEventListener('resize', handleResize), [handleResize], 1000);

  useEffect(() => {
    setContentHeight(!isExpanded || expandableRef.current === null ? '0px' : `${expandableRef.current.scrollHeight}px`);
  }, [children, isExpanded]);

  useEffect(() => {
    setContentHeight(!isExpanded || expandableRef.current === null ? '0px' : `${expandableRef.current.scrollHeight}px`);
  }, [resizeTrigger, height, contentHeight]);

  return (
    <div className={styles.accordionContainer}>
      <div className={styles.accordionText} ref={expandableRef} style={{ maxHeight: `${contentHeight}` }}>
        {children}
      </div>
    </div>
  );
};

export default ExpandableGenericDynamic;
